import { render } from "./sidebarProfileView.vue?vue&type=template&id=f744cc5e&scoped=true"
import script from "./sidebarProfileView.vue?vue&type=script&lang=js"
export * from "./sidebarProfileView.vue?vue&type=script&lang=js"

import "./sidebarProfileView.vue?vue&type=style&index=0&id=f744cc5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f744cc5e"]])

export default __exports__